import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {TableContainer, withStyles} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Paper from "@material-ui/core/Paper";
import client from "../lib/api/client";
import {withRouter} from "react-router-dom";
import TitleHead from "../assets/title_head.svg";
import {setSelectedItem} from "../modules/menu";
import {useDispatch} from "react-redux";
import {useRecoilValue} from "recoil";
import {userState} from "../state/globalState";
import moment from "moment";

const useStyles = makeStyles(theme => ({
    root: {
        height: "100%",
        width: "100%",
        margin: "30px 0"
    },
    wtireButton: {
        display: "flex",
        width: "100%",
        justifyContent: "flex-end"
    },
    boardWrapper: {
        marginTop: "10px"
    },
    title: {
        cursor: "pointer"
    }
}));

const QuestionBoard = ({ setViewState, history }) => {
    const userInfo = useRecoilValue(userState);
    const [rows, setRows] = useState(null);
    const classes = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        client.get('/kognr/list', {
            cache: false,
            params: {
                stdYear: userInfo.stdYear,
                admnNo: userInfo.admnNo
            }
        }).then(response => {
            // console.log("res : ", response.data.payload);
            setRows(response.data.payload);
        }).catch((error) => {
            console.log(error.response);
        });

        dispatch(setSelectedItem("BOARD"));

    }, []);

    const StyledTableCell = withStyles((theme) => ({
        head: {
            backgroundColor: "#1b6817",
            color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }))(TableCell);

    const StyledTableRow = withStyles((theme) => ({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.action.hover,
            },
        },
    }))(TableRow);

    const handleTitleClick = (brdNo) => {
        setViewState("VIEW");
        history.push(`/question/${brdNo}`);
    }

    // function createData(num, title, date, status) {
    //     return { num, title, date, status };
    // }

    // const rows = [
    //     createData(1, '세미콜론의 띄어쓰기', "2021. 12. 17.", "확인중"),
    //     createData(2, '애플펜슬은 외래어인데 우리말로 쓸 때 띄어쓰기를 해야', "2021. 12. 17.", "답변완료"),
    //     createData(3, '[재질문] 책상에 앉다? 의자에 앉다?', "2021. 12. 17.", "상태"),
    //     createData(4, 'Cupcake', "2021. 12. 17.", "상태"),
    //     createData(5, 'Gingerbread', "2021. 12. 17.", "상태"),
    // ];

    return (
            <Grid container
                  direction="column"
                  alignItems="flex-start"
                  justifyContent="center"
            >
                <div className={classes.root}>
                    <div className="title-head">
                        <img src={TitleHead}/>
                        <span>1:1 문의</span>
                    </div>
                    <div className={classes.wtireButton}>
                        <Button variant="outlined" color="primary" onClick={() => setViewState("WRITE")}>
                            글쓰기
                        </Button>
                    </div>
                    <div className={classes.boardWrapper}>
                        <TableContainer component={Paper}>
                            <Table aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell className={classes.th} align="center">번호</StyledTableCell>
                                        <StyledTableCell className={classes.th} align="center">제목</StyledTableCell>
                                        <StyledTableCell align="center">작성일</StyledTableCell>
                                        <StyledTableCell align="center">상태</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows && rows.map((row) => (
                                        // row.ansGcd === "HC061002" ? (
                                        //     <StyledTableRow key={row.BRD_NO}>
                                        //         <StyledTableCell align="center"></StyledTableCell>
                                        //         <StyledTableCell component="th" scope="row">
                                        //             [답변] {row.TITLE}
                                        //         </StyledTableCell>
                                        //         <StyledTableCell align="center">{moment(new Date(row.crtDate)).format("YYYY-MM-DD HH:mm:ss")}</StyledTableCell>
                                        //         <StyledTableCell align="center">{row.ANS}</StyledTableCell>
                                        //     </StyledTableRow>
                                        //     ) : (
                                                <StyledTableRow key={row.brdNo}>
                                                    <StyledTableCell align="center">{row.brdNo}</StyledTableCell>
                                                    <StyledTableCell component="th" scope="row">
                                                        <span className={classes.title} onClick={() => handleTitleClick(row.brdNo)}>{row.title}</span>
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">{moment(new Date(row.crtDate)).format("YYYY-MM-DD HH:mm:ss")}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.ansGcd === "HC061001" || row.ansGcd === "HC061004"  ? "미답변" : row.ansGcd === "HC061002" ? "답변완료" : "마감"}</StyledTableCell>
                                                </StyledTableRow>
                                            // )
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </Grid>
    );
};

export default withRouter(QuestionBoard);
